import { AnimatePresence } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TimersContext, TwitchChannelContext } from "../../contexts/index.js";
import useEbsApiClient from "../../hooks/useEbsApiClient.js";
import useFollowerRaffleLogic, {
  FOLLOWER_STATUSES,
} from "../../hooks/useFollowerRaffleLogic.js";
import useMessages from "../../hooks/useMessages.js";
import Flyout from "../Flyout/Flyout.js";
import FollowerBuilder from "../FollowerBuilder/FollowerBuilder.js";
import HelpHinder from "../HelpHinder/HelpHinder.js";
import OverlayMessagesContainer from "../OverlayMessagesContainer/OverlayMessagesContainer.js";
import Raffle from "../Raffle/Raffle.js";
import SafeZones from "../SafeZones/SafeZones.js";

const VideoOverlay = () => {
  const {
    activeRaffle,
    enterRaffle,
    dismissRaffle,
    permanentlyDismissRaffle,
    follower,
    createFollower,
    premiumBitsCost,
  } = useFollowerRaffleLogic();
  const [channelInfo, setChannelInfo] = useState(null);
  const [timers, setTimers] = useState(null);
  const ebsApiClient = useEbsApiClient();
  const { i18n } = useTranslation();

  useEffect(() => {
    (async () => {
      const [{ data: channelData }, { data: timersData }] = await Promise.all([
        ebsApiClient.get("/channel"),
        ebsApiClient.get("/timers"),
      ]);
      i18n.changeLanguage(channelData.language || "en");
      setChannelInfo(channelData);
      setTimers(timersData);
    })();
  }, []);

  if (!channelInfo || !timers) {
    return null;
  }

  return (
    <TwitchChannelContext.Provider value={channelInfo}>
      <TimersContext.Provider value={timers}>
        <SafeZones />
        <HelpHinder />
        <OverlayMessagesContainer />
        <AnimatePresence>
          {Boolean(activeRaffle) && (
            <Raffle
              activeRaffle={activeRaffle}
              hasFollower={Boolean(follower)}
              onDismissRaffle={dismissRaffle}
              onPermanentlyDismissRaffle={permanentlyDismissRaffle}
              onEnterRaffle={enterRaffle}
            />
          )}
        </AnimatePresence>
        {Boolean(
          follower && follower.status === FOLLOWER_STATUSES.READY_FOR_CREATION
        ) && (
          <Flyout direction="left">
            <FollowerBuilder
              premiumBitsCost={premiumBitsCost}
              onFinishBuilding={createFollower}
            />
          </Flyout>
        )}
      </TimersContext.Provider>
    </TwitchChannelContext.Provider>
  );
};

export default VideoOverlay;
